import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Swallow benign cross-origin "Script error." messages that CRA dev overlay
// catches from Cloudflare Turnstile's sandboxed iframe. Real errors still show.
if (typeof window !== "undefined") {
  window.addEventListener(
    "error",
    (e) => {
      const msg = e?.message || "";
      const src = e?.filename || "";
      if (
        msg === "Script error." ||
        src.includes("challenges.cloudflare.com") ||
        src.includes("recaptcha")
      ) {
        e.stopImmediatePropagation();
        e.preventDefault?.();
        return false;
      }
    },
    true,
  );
  window.addEventListener("unhandledrejection", (e) => {
    const reason = String(e?.reason || "");
    if (reason.includes("challenges.cloudflare.com")) {
      e.preventDefault?.();
    }
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
